module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_492015.e7a0c7ce.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetInRecargas/FormatoSimplificado_492015.pdf
// module id = 885
// module chunks = 0